export const RECIPE_TYPE_OPTIONS = [
  { value: "all", label: "All" },
  { value: "finished", label: "Finished" },
  { value: "intermediate", label: "Intermediate" },
  { value: "auxiliary", label: "Auxiliary" },
];

export const RECIPES_UI_STYLES = `
  .rcx-shell {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-height: 100%;
    height: 100%;
    min-width: 0;
    padding: 24px;
    overflow: hidden;
    color: rgba(240, 245, 255, 0.96);
    background:
      radial-gradient(880px 340px at 0% 0%, rgba(34, 211, 238, 0.11), transparent 68%),
      radial-gradient(720px 360px at 100% 0%, rgba(249, 115, 22, 0.09), transparent 64%),
      radial-gradient(1100px 540px at 50% 120%, rgba(52, 211, 153, 0.08), transparent 60%),
      linear-gradient(180deg, #07101f 0%, #091221 42%, #0a1322 100%);
  }

  .rcx-shell *,
  .rcx-shell *::before,
  .rcx-shell *::after {
    box-sizing: border-box;
  }

  .rcx-page {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    gap: 14px;
    min-height: 0;
    overflow: hidden;
  }

  .rcx-headerCard {
    flex: 0 0 auto;
    border-radius: 18px;
    border: 1px solid transparent;
    background:
      linear-gradient(180deg, rgba(24, 28, 46, 0.92), rgba(9, 11, 22, 0.92)) padding-box,
      linear-gradient(135deg, rgba(48, 216, 255, 0.45), rgba(12, 153, 204, 0.38), rgba(26, 188, 156, 0.32)) border-box;
    box-shadow: 0 22px 70px rgba(0, 0, 0, 0.55);
    overflow: hidden;
    position: relative;
  }

  .rcx-headerCard::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    background:
      radial-gradient(540px 240px at 5% 0%, rgba(48, 216, 255, 0.11), transparent 70%),
      radial-gradient(520px 220px at 95% 15%, rgba(26, 188, 156, 0.1), transparent 72%);
    opacity: 0.9;
  }

  .rcx-headerCard > * {
    position: relative;
    z-index: 1;
  }

  .rcx-headerHead {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 14px;
    padding: 20px 20px 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.08);
  }

  .rcx-headerTitle {
    margin: 0;
    font-size: 1.35rem;
    font-weight: 900;
    color: rgba(240, 245, 255, 0.95);
    letter-spacing: 0.2px;
  }

  .rcx-headerSubtitle {
    margin: 6px 0 0;
    color: rgba(219, 228, 243, 0.66);
    font-size: 0.9rem;
    line-height: 1.5;
    max-width: 620px;
  }

  .rcx-headerControls {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    width: min(620px, 100%);
  }

  .rcx-input--header,
  .rcx-select--header {
    border-radius: 12px;
    padding: 10px 12px;
  }

  .rcx-filterChips {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: flex-end;
    width: 100%;
  }

  .rcx-filterChip {
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 999px;
    padding: 5px 10px;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.1px;
    color: rgba(226, 234, 247, 0.82);
    background: rgba(255, 255, 255, 0.03);
    transition: border-color 120ms ease, transform 120ms ease, background 120ms ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
  }

  .rcx-filterChip span {
    min-width: 19px;
    text-align: center;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.12);
    padding: 1px 6px;
    color: rgba(245, 248, 255, 0.95);
    font-size: 0.72rem;
  }

  .rcx-filterChip:hover {
    transform: translateY(-1px);
  }

  .rcx-filterChip--active {
    border-color: rgba(48, 216, 255, 0.62);
    background: rgba(48, 216, 255, 0.15);
    color: rgba(198, 244, 255, 0.95);
    box-shadow: 0 0 0 2px rgba(48, 216, 255, 0.13);
  }

  .rcx-headerError {
    padding: 14px 20px 0;
  }

  .rcx-workspace {
    display: grid;
    grid-template-columns: minmax(320px, 30%) minmax(0, 1fr);
    gap: 14px;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  }

  .rcx-previewColumn,
  .rcx-tableColumn {
    display: flex;
    min-width: 0;
    min-height: 0;
  }

  .rcx-previewBody {
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
    padding: 14px 16px 16px;
    scrollbar-width: thin;
    scrollbar-color: rgba(109, 208, 235, 0.72) rgba(255, 255, 255, 0.08);
  }

  .rcx-previewBody .rcx-focusCard {
    flex: 1 1 auto;
  }

  .rcx-previewBody .rcx-focusMedia {
    aspect-ratio: 4 / 3;
    min-height: clamp(160px, 22vh, 220px);
  }

  .rcx-previewBlock {
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.03);
    padding: 12px;
  }

  .rcx-previewBlockTitle {
    margin-bottom: 6px;
    color: rgba(244, 248, 255, 0.96);
    font-size: 0.78rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .rcx-topbar {
    display: flex;
    flex: 0 0 auto;
    padding: 14px 18px;
    border-radius: 22px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background:
      linear-gradient(180deg, rgba(11, 17, 32, 0.96), rgba(8, 13, 25, 0.96)) padding-box,
      linear-gradient(135deg, rgba(34, 211, 238, 0.18), rgba(59, 130, 246, 0.08), rgba(249, 115, 22, 0.12)) border-box;
    box-shadow: 0 14px 34px rgba(2, 8, 20, 0.2);
    overflow: hidden;
  }

  .rcx-topbarIntro {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    gap: 10px;
    min-height: 0;
    min-width: 0;
  }

  .rcx-topbarHeader {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    flex-wrap: wrap;
  }

  .rcx-topbarMain {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
    flex: 1 1 540px;
  }

  .rcx-topbarTitle {
    margin: 0;
    font-size: clamp(1.36rem, 1.8vw, 1.95rem);
    line-height: 1.08;
    letter-spacing: -0.04em;
    font-weight: 850;
    color: rgba(245, 248, 255, 0.99);
  }

  .rcx-topbarCopy {
    color: rgba(209, 221, 244, 0.72);
    font-size: 0.84rem;
    line-height: 1.45;
    max-width: 720px;
  }

  .rcx-actions--compact {
    margin-top: 0;
    align-self: flex-start;
  }

  .rcx-topbarSummary {
    display: grid;
    grid-template-columns: max-content minmax(360px, 1fr);
    gap: 12px;
    align-items: stretch;
  }

  .rcx-topbarStats {
    display: grid;
    grid-template-columns: repeat(4, max-content);
    gap: 8px;
    align-content: start;
    justify-content: start;
    width: max-content;
    max-width: 100%;
  }

  .rcx-topbarStats .rcx-stat {
    min-width: 108px;
  }

  .rcx-topbarNavigator {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px 14px;
    border-radius: 18px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    background:
      radial-gradient(520px 180px at 0% 0%, rgba(34, 211, 238, 0.035), transparent 72%),
      rgba(255, 255, 255, 0.015);
  }

  .rcx-topbarNavigatorHead {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }

  .rcx-topbarNavigatorBody {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .rcx-topbarSignals {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .rcx-topbarNavigator .rcx-panelTitle {
    font-size: 0.92rem;
  }

  .rcx-topbarNavigator .rcx-panelSubtitle {
    margin-top: 4px;
    font-size: 0.78rem;
    max-width: 520px;
  }

  .rcx-topbarFeature {
    display: grid;
    grid-template-columns: minmax(240px, 300px) minmax(0, 1fr);
    gap: 14px;
    min-width: 0;
    min-height: 210px;
    padding: 10px;
    border-radius: 22px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background:
      radial-gradient(420px 180px at 0% 0%, rgba(34, 211, 238, 0.08), transparent 72%),
      rgba(255, 255, 255, 0.025);
  }

  .rcx-featureMedia {
    aspect-ratio: 1 / 1;
    min-height: 240px;
    border-radius: 18px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
  }

  .rcx-featureBody {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 12px;
    min-width: 0;
    padding: 6px 2px 6px 0;
  }

  .rcx-featureTitle {
    margin: 0;
    font-size: 1.26rem;
    font-weight: 900;
    letter-spacing: -0.03em;
    color: rgba(248, 251, 255, 0.99);
  }

  .rcx-featureCopy {
    color: rgba(229, 237, 250, 0.78);
    font-size: 0.84rem;
    line-height: 1.58;
  }

  .rcx-featureStats {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .rcx-previewMetrics {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
  }

  .rcx-previewMetricChip {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    flex: 1 1 calc(50% - 7px);
    min-width: 132px;
    max-width: 100%;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    background: rgba(255, 255, 255, 0.03);
    padding: 7px 10px;
  }

  .rcx-previewMetricChip span {
    min-width: 0;
    overflow: hidden;
    color: rgba(211, 223, 244, 0.62);
    font-size: 0.63rem;
    font-weight: 850;
    letter-spacing: 0.05em;
    text-overflow: ellipsis;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .rcx-previewMetricChip strong {
    min-width: 0;
    overflow: hidden;
    color: rgba(244, 248, 255, 0.98);
    font-size: 0.78rem;
    font-weight: 900;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .rcx-dashboard {
    display: grid;
    grid-template-columns: 360px minmax(0, 1fr);
    gap: 14px;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  }

  .rcx-rail,
  .rcx-stage {
    display: flex;
    min-height: 0;
    min-width: 0;
  }

  .rcx-panel--fill {
    flex: 1 1 auto;
    min-height: 0;
  }

  .rcx-railBody {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-height: 0;
    padding: 14px 16px 16px;
  }

  .rcx-compactRow {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 170px;
    gap: 10px;
    align-items: center;
  }

  .rcx-compactStats {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .rcx-cardScroller {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 0;
    overflow: auto;
    padding-right: 4px;
    scrollbar-width: thin;
    scrollbar-color: rgba(109, 208, 235, 0.72) rgba(255, 255, 255, 0.08);
  }

  .rcx-navCard {
    display: grid;
    grid-template-columns: 92px minmax(0, 1fr);
    gap: 12px;
    padding: 10px;
    border-radius: 18px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.02);
    cursor: pointer;
    transition: border-color 120ms ease, background 120ms ease, transform 120ms ease, box-shadow 120ms ease;
  }

  .rcx-navCard:hover {
    transform: translateY(-1px);
    border-color: rgba(34, 211, 238, 0.22);
    background: rgba(255, 255, 255, 0.036);
    box-shadow: 0 18px 42px rgba(0, 0, 0, 0.22);
  }

  .rcx-navCard--active {
    border-color: rgba(34, 211, 238, 0.32);
    background: rgba(34, 211, 238, 0.08);
    box-shadow: 0 0 0 1px rgba(34, 211, 238, 0.1);
  }

  .rcx-placeholderCard {
    flex: 1 1 auto;
    min-height: 260px;
    border-radius: 20px;
    border: 1px dashed rgba(255, 255, 255, 0.14);
    background:
      radial-gradient(420px 180px at 0% 0%, rgba(34, 211, 238, 0.04), transparent 72%),
      rgba(255, 255, 255, 0.018);
  }

  .rcx-focusCard {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background:
      radial-gradient(420px 180px at 0% 0%, rgba(34, 211, 238, 0.05), transparent 72%),
      rgba(255, 255, 255, 0.02);
    overflow: hidden;
  }

  .rcx-focusMedia {
    aspect-ratio: 1 / 1;
    min-height: 260px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .rcx-focusBody {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    gap: 12px;
    padding: 14px;
    min-height: 0;
  }

  .rcx-navMedia {
    min-height: 96px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .rcx-navBody {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
  }

  .rcx-navTitle {
    margin: 0;
    font-size: 0.92rem;
    font-weight: 850;
    color: rgba(247, 250, 255, 0.98);
  }

  .rcx-navMeta {
    color: rgba(205, 219, 242, 0.66);
    font-size: 0.74rem;
    line-height: 1.45;
  }

  .rcx-navMetrics {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
  }

  .rcx-navMetric {
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(255, 255, 255, 0.025);
    padding: 8px 9px;
  }

  .rcx-navMetricLabel {
    color: rgba(213, 224, 244, 0.58);
    font-size: 0.62rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 800;
    margin-bottom: 3px;
  }

  .rcx-navMetricValue {
    color: rgba(244, 248, 255, 0.96);
    font-size: 0.74rem;
    font-weight: 850;
    line-height: 1.25;
  }

  .rcx-stageBody {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
  }

  .rcx-stageToolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    padding: 14px 18px 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.015);
  }

  .rcx-stageMetrics {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .rcx-stageAction {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .rcx-heroCard,
  .rcx-panel,
  .rcx-composer,
  .rcx-previewCard {
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background:
      linear-gradient(180deg, rgba(11, 17, 32, 0.98), rgba(8, 13, 25, 0.98)) padding-box,
      linear-gradient(135deg, rgba(34, 211, 238, 0.18), rgba(59, 130, 246, 0.08), rgba(249, 115, 22, 0.12)) border-box;
    box-shadow: 0 28px 80px rgba(2, 8, 20, 0.34);
    overflow: hidden;
  }

  .rcx-heroCard {
    padding: 22px;
    display: grid;
    grid-template-columns: minmax(0, 1.15fr) minmax(320px, 0.85fr);
    gap: 18px;
    align-items: stretch;
  }

  .rcx-kicker {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    color: rgba(140, 232, 255, 0.88);
    font-size: 0.72rem;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.2em;
  }

  .rcx-title {
    margin: 0;
    font-size: clamp(1.8rem, 3vw, 3rem);
    font-weight: 900;
    letter-spacing: -0.04em;
    line-height: 0.98;
    color: rgba(245, 248, 255, 0.99);
  }

  .rcx-subtitle {
    margin: 14px 0 0;
    max-width: 760px;
    color: rgba(209, 221, 244, 0.72);
    font-size: 0.94rem;
    line-height: 1.65;
  }

  .rcx-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 18px;
  }

  .rcx-btn,
  .rcx-chip,
  .rcx-inlineBtn,
  .rcx-closeBtn,
  .rcx-galleryAdd,
  .rcx-imageRemove {
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.04);
    color: rgba(226, 235, 249, 0.84);
    padding: 8px 14px;
    font-size: 0.78rem;
    font-weight: 800;
    cursor: pointer;
    transition: transform 120ms ease, border-color 120ms ease, background 120ms ease, box-shadow 120ms ease;
  }

  .rcx-btn:hover,
  .rcx-chip:hover,
  .rcx-inlineBtn:hover,
  .rcx-closeBtn:hover,
  .rcx-galleryAdd:hover,
  .rcx-imageRemove:hover {
    transform: translateY(-1px);
  }

  .rcx-btn--primary {
    border-color: rgba(34, 211, 238, 0.55);
    background: linear-gradient(135deg, rgba(34, 211, 238, 0.96), rgba(59, 130, 246, 0.9));
    color: #07131e;
  }

  .rcx-btn--warm {
    border-color: rgba(251, 146, 60, 0.5);
    background: linear-gradient(135deg, rgba(251, 146, 60, 0.96), rgba(249, 115, 22, 0.9));
    color: #1a1208;
  }

  .rcx-btn--ghost {
    background: transparent;
  }

  .rcx-chipRow {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .rcx-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    max-width: 100%;
    overflow-wrap: anywhere;
  }

  .rcx-chip--active {
    border-color: rgba(34, 211, 238, 0.58);
    background: rgba(34, 211, 238, 0.16);
    color: rgba(214, 251, 255, 0.95);
    box-shadow: 0 0 0 2px rgba(34, 211, 238, 0.09);
  }

  .rcx-chip--accent {
    border-color: rgba(249, 115, 22, 0.42);
    background: rgba(249, 115, 22, 0.12);
    color: rgba(255, 223, 205, 0.94);
  }

  .rcx-input,
  .rcx-select,
  .rcx-textarea {
    width: 100%;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.05);
    color: rgba(240, 245, 255, 0.95);
    padding: 12px 14px;
    outline: none;
    box-shadow: none;
  }

  .rcx-input::placeholder,
  .rcx-textarea::placeholder {
    color: rgba(217, 229, 247, 0.42);
  }

  .rcx-input:focus,
  .rcx-select:focus,
  .rcx-textarea:focus {
    border-color: rgba(48, 216, 255, 0.58);
    box-shadow: 0 0 0 3px rgba(48, 216, 255, 0.14);
  }

  .rcx-select option {
    color: #091221;
    background: #ffffff;
  }

  .rcx-searchRow {
    display: grid;
    grid-template-columns: minmax(280px, 1.35fr) minmax(220px, 0.65fr);
    gap: 12px;
    align-items: center;
  }

  .rcx-note {
    color: rgba(205, 219, 242, 0.7);
    font-size: 0.8rem;
    line-height: 1.5;
  }

  .rcx-spotlight {
    position: relative;
    min-height: 280px;
    border-radius: 22px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background:
      linear-gradient(180deg, rgba(7, 12, 22, 0.12), rgba(7, 12, 22, 0.82)),
      radial-gradient(420px 180px at 20% 0%, rgba(34, 211, 238, 0.22), transparent 66%),
      linear-gradient(135deg, rgba(12, 23, 42, 0.92), rgba(14, 18, 34, 0.96));
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
  }

  .rcx-spotlight::after {
    content: "";
    position: absolute;
    inset: 0;
    background:
      linear-gradient(180deg, rgba(6, 9, 18, 0.08), rgba(6, 9, 18, 0.88)),
      linear-gradient(140deg, rgba(34, 211, 238, 0.06), transparent 36%, rgba(249, 115, 22, 0.12));
    pointer-events: none;
  }

  .rcx-spotlightMedia {
    position: absolute;
    inset: 0;
    background-position: center;
    background-size: cover;
    filter: saturate(1.08);
    transform: scale(1.02);
  }

  .rcx-spotlightContent {
    position: relative;
    z-index: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 12px;
    padding: 22px;
  }

  .rcx-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    width: fit-content;
    border-radius: 999px;
    padding: 7px 11px;
    border: 1px solid rgba(255, 255, 255, 0.16);
    background: rgba(7, 14, 28, 0.44);
    backdrop-filter: blur(10px);
    color: rgba(238, 244, 255, 0.92);
    font-size: 0.72rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .rcx-spotlightTitle {
    margin: 0;
    font-size: clamp(1.4rem, 2vw, 2.15rem);
    font-weight: 900;
    letter-spacing: -0.03em;
    color: rgba(248, 251, 255, 0.99);
  }

  .rcx-spotlightCopy {
    max-width: 560px;
    color: rgba(231, 238, 250, 0.8);
    font-size: 0.9rem;
    line-height: 1.6;
  }

  .rcx-spotlightStats {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .rcx-statPill,
  .rcx-typeBadge {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    border-radius: 999px;
    padding: 8px 12px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(7, 14, 28, 0.52);
    color: rgba(239, 244, 255, 0.95);
    backdrop-filter: blur(10px);
    font-size: 0.76rem;
    font-weight: 800;
  }

  .rcx-typeBadge--finished {
    border-color: rgba(34, 211, 238, 0.38);
    background: rgba(34, 211, 238, 0.12);
    color: rgba(214, 251, 255, 0.98);
  }

  .rcx-typeBadge--intermediate {
    border-color: rgba(52, 211, 153, 0.4);
    background: rgba(52, 211, 153, 0.12);
    color: rgba(210, 255, 233, 0.98);
  }

  .rcx-typeBadge--auxiliary {
    border-color: rgba(251, 146, 60, 0.42);
    background: rgba(251, 146, 60, 0.13);
    color: rgba(255, 228, 211, 0.98);
  }

  .rcx-banner {
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    padding: 11px 14px;
    font-size: 0.82rem;
    font-weight: 700;
  }

  .rcx-banner--success {
    border-color: rgba(52, 211, 153, 0.36);
    background: rgba(52, 211, 153, 0.12);
    color: rgba(188, 248, 220, 0.98);
  }

  .rcx-banner--error {
    border-color: rgba(248, 113, 113, 0.36);
    background: rgba(248, 113, 113, 0.12);
    color: rgba(255, 210, 210, 0.98);
  }

  .rcx-banner--info {
    border-color: rgba(34, 211, 238, 0.34);
    background: rgba(34, 211, 238, 0.12);
    color: rgba(205, 247, 255, 0.98);
  }

  .rcx-panel {
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    width: 100%;
  }

  .rcx-panelHead {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 14px;
    padding: 18px 20px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    min-width: 0;
    width: 100%;
  }

  .rcx-panelHead > * {
    min-width: 0;
  }

  .rcx-panelHeadActions {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 8px;
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
    min-width: 0;
  }

  .rcx-panelHead--list {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: start;
  }

  .rcx-panelHeadActions .rcx-btn {
    white-space: nowrap;
  }

  .rcx-panelTitle {
    margin: 0;
    font-size: 1.08rem;
    font-weight: 850;
    color: rgba(245, 248, 255, 0.97);
  }

  .rcx-panelSubtitle {
    margin: 6px 0 0;
    color: rgba(201, 214, 238, 0.66);
    font-size: 0.84rem;
    line-height: 1.45;
    max-width: 760px;
  }

  .rcx-toolbar {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background:
      radial-gradient(720px 220px at 12% 0%, rgba(34, 211, 238, 0.06), transparent 72%),
      rgba(255, 255, 255, 0.02);
  }

  .rcx-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
    padding: 14px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.015);
  }

  .rcx-stat {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 14px;
    padding: 9px 11px;
    background: rgba(255, 255, 255, 0.02);
  }

  .rcx-statLabel {
    margin-bottom: 3px;
    color: rgba(213, 224, 244, 0.62);
    font-size: 0.62rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-weight: 800;
  }

  .rcx-statValue {
    color: rgba(244, 248, 255, 0.98);
    font-size: 0.94rem;
    font-weight: 850;
    line-height: 1.15;
  }

  .rcx-gallerySection {
    padding: 18px 20px 22px;
  }

  .rcx-cardGrid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 14px;
  }

  .rcx-recipeCard {
    display: flex;
    flex-direction: column;
    min-height: 0;
    border-radius: 22px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.025);
    box-shadow: 0 20px 56px rgba(0, 0, 0, 0.26);
    cursor: pointer;
    transition: transform 140ms ease, border-color 140ms ease, box-shadow 140ms ease, background 140ms ease;
  }

  .rcx-recipeCard:hover {
    transform: translateY(-2px);
    border-color: rgba(34, 211, 238, 0.22);
    background: rgba(255, 255, 255, 0.038);
    box-shadow: 0 28px 72px rgba(0, 0, 0, 0.32);
  }

  .rcx-recipeMedia {
    position: relative;
    min-height: 190px;
    background:
      linear-gradient(180deg, rgba(6, 9, 18, 0.08), rgba(6, 9, 18, 0.78)),
      radial-gradient(320px 140px at 16% 0%, rgba(34, 211, 238, 0.18), transparent 64%),
      linear-gradient(135deg, rgba(11, 23, 42, 0.92), rgba(15, 18, 34, 0.98));
    background-position: center;
    background-size: cover;
  }

  .rcx-recipeMedia::after {
    content: "";
    position: absolute;
    inset: 0;
    background:
      linear-gradient(180deg, rgba(7, 12, 22, 0.06), rgba(7, 12, 22, 0.84)),
      linear-gradient(140deg, rgba(34, 211, 238, 0.06), transparent 44%, rgba(249, 115, 22, 0.1));
    pointer-events: none;
  }

  .rcx-recipeMediaTop,
  .rcx-recipeMediaBottom {
    position: absolute;
    left: 14px;
    right: 14px;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .rcx-recipeMediaTop {
    top: 14px;
    align-items: flex-start;
  }

  .rcx-recipeMediaBottom {
    bottom: 14px;
    align-items: flex-end;
  }

  .rcx-recipeBody {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    gap: 12px;
    padding: 16px 16px 18px;
  }

  .rcx-cardTitle {
    margin: 0;
    font-size: 1.05rem;
    font-weight: 900;
    letter-spacing: -0.03em;
    color: rgba(247, 250, 255, 0.98);
  }

  .rcx-cardCode {
    color: rgba(131, 229, 255, 0.92);
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.14em;
    font-weight: 800;
  }

  .rcx-cardCopy {
    color: rgba(212, 224, 245, 0.72);
    font-size: 0.83rem;
    line-height: 1.6;
  }

  .rcx-cardMetrics {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .rcx-miniMetric {
    border-radius: 15px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.03);
    padding: 10px 11px;
  }

  .rcx-miniLabel {
    color: rgba(211, 223, 244, 0.58);
    font-size: 0.66rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-weight: 800;
    margin-bottom: 4px;
  }

  .rcx-miniValue {
    color: rgba(244, 248, 255, 0.96);
    font-size: 0.83rem;
    font-weight: 800;
    line-height: 1.25;
  }

  .rcx-thumbRow {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .rcx-thumb {
    width: 48px;
    height: 48px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    box-shadow: 0 12px 26px rgba(0, 0, 0, 0.22);
  }

  .rcx-legendList {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .rcx-legendItem {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
    padding: 12px 14px;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.025);
  }

  .rcx-legendMeta {
    min-width: 0;
  }

  .rcx-legendTitle {
    color: rgba(244, 248, 255, 0.96);
    font-size: 0.84rem;
    font-weight: 850;
  }

  .rcx-legendCopy {
    margin-top: 4px;
    color: rgba(205, 219, 242, 0.66);
    font-size: 0.76rem;
    line-height: 1.5;
  }

  .rcx-legendValue {
    color: rgba(255, 223, 205, 0.98);
    font-size: 0.84rem;
    font-weight: 900;
    white-space: nowrap;
  }

  .rcx-tableWrap {
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0;
    width: 100%;
    max-width: 100%;
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(109, 208, 235, 0.72) rgba(255, 255, 255, 0.08);
  }

  .rcx-table {
    width: 100%;
    min-width: 1180px;
    border-collapse: separate;
    border-spacing: 0;
  }

  .rcx-table--recipes {
    min-width: 0;
    table-layout: fixed;
  }

  .rcx-table--recipes th:nth-child(1),
  .rcx-table--recipes td:nth-child(1) {
    width: 18%;
  }

  .rcx-table--recipes th:nth-child(2),
  .rcx-table--recipes td:nth-child(2) {
    width: 12%;
  }

  .rcx-table--recipes th:nth-child(3),
  .rcx-table--recipes td:nth-child(3) {
    width: 9%;
  }

  .rcx-table--recipes th:nth-child(4),
  .rcx-table--recipes td:nth-child(4),
  .rcx-table--recipes th:nth-child(5),
  .rcx-table--recipes td:nth-child(5) {
    width: 10%;
  }

  .rcx-table--recipes th:nth-child(6),
  .rcx-table--recipes td:nth-child(6) {
    width: 7%;
    text-align: center;
  }

  .rcx-table--recipes th:nth-child(7),
  .rcx-table--recipes td:nth-child(7) {
    width: 10%;
  }

  .rcx-table--recipes th:nth-child(8),
  .rcx-table--recipes td:nth-child(8) {
    width: 15%;
  }

  .rcx-table--recipes th:nth-child(9),
  .rcx-table--recipes td:nth-child(9) {
    width: 9%;
    text-align: right;
  }

  .rcx-table thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    padding: 12px;
    text-align: left;
    font-size: 0.73rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 800;
    color: rgba(214, 227, 247, 0.82);
    background: linear-gradient(180deg, rgba(25, 31, 53, 0.98), rgba(14, 18, 34, 0.98));
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    white-space: nowrap;
  }

  .rcx-table tbody tr {
    background: rgba(255, 255, 255, 0.018);
    transition: background 120ms ease, transform 120ms ease, box-shadow 120ms ease;
  }

  .rcx-table tbody tr:nth-child(even) {
    background: rgba(255, 255, 255, 0.012);
  }

  .rcx-table tbody tr:hover {
    background: rgba(48, 216, 255, 0.055);
    transform: translateY(-1px);
    box-shadow: 0 16px 44px rgba(0, 0, 0, 0.22);
  }

  .rcx-table tbody tr.rcx-tableRow--active,
  .rcx-table tbody tr.rcx-tableRow--active:nth-child(even) {
    background: rgba(48, 216, 255, 0.11);
    box-shadow: inset 3px 0 0 rgba(48, 216, 255, 0.92);
  }

  .rcx-table tbody td {
    padding: 11px 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    color: rgba(234, 241, 252, 0.88);
    font-size: 0.82rem;
    vertical-align: middle;
  }

  .rcx-table--recipes td {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .rcx-table--recipes th {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .rcx-table--recipes .rcx-linkBtn,
  .rcx-table--recipes .rcx-muted {
    display: block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .rcx-storyCell {
    white-space: nowrap;
  }

  .rcx-linkBtn {
    border: 0;
    background: transparent;
    padding: 0;
    color: rgba(126, 229, 255, 0.94);
    font-weight: 850;
    cursor: pointer;
    text-align: left;
  }

  .rcx-linkBtn:hover {
    color: rgba(190, 244, 255, 0.98);
  }

  .rcx-muted {
    color: rgba(208, 221, 244, 0.72);
  }

  .rcx-strong {
    color: rgba(245, 249, 255, 0.97);
    font-weight: 850;
  }

  .rcx-empty {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: rgba(205, 219, 242, 0.68);
    padding: 26px 18px;
    font-size: 0.94rem;
  }

  .rcx-emptyCard {
    padding: 18px;
    border-radius: 18px;
    border: 1px dashed rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.025);
    color: rgba(209, 221, 244, 0.72);
    text-align: center;
  }

  .rcx-tableWrap--ledger {
    flex: 1 1 auto;
    min-height: 300px;
    min-width: 0;
  }

  .rcx-modalBackdrop {
    --rcx-composer-gutter: 20px;
    --rcx-composer-zoom: 1;
    box-sizing: border-box;
    position: fixed;
    inset: 0;
    z-index: 1250;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100dvw;
    height: 100dvh;
    padding: 10px;
    background: rgba(4, 8, 18, 0.74);
    backdrop-filter: blur(16px);
    transform: none !important;
    zoom: 1 !important;
  }

  .rcx-composer {
    width: min(
      calc(1840px / var(--rcx-composer-zoom)),
      calc((100dvw - var(--rcx-composer-gutter)) / var(--rcx-composer-zoom))
    );
    height: calc((100dvh - var(--rcx-composer-gutter)) / var(--rcx-composer-zoom));
    max-width: none;
    max-height: none;
    display: flex;
    flex-direction: column;
    min-height: 0;
    zoom: var(--rcx-composer-zoom);
  }

  .rcx-composerHeader {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    padding: 16px 18px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background:
      radial-gradient(560px 220px at 0% 0%, rgba(34, 211, 238, 0.12), transparent 72%),
      radial-gradient(420px 220px at 100% 0%, rgba(249, 115, 22, 0.12), transparent 68%),
      rgba(255, 255, 255, 0.02);
  }

  .rcx-composerTitle {
    margin: 0;
    font-size: clamp(1.28rem, 1.65vw, 1.82rem);
    font-weight: 900;
    letter-spacing: -0.03em;
    color: rgba(247, 250, 255, 0.99);
  }

  .rcx-composerSubtitle {
    margin: 6px 0 0;
    color: rgba(205, 219, 242, 0.74);
    font-size: 0.82rem;
    line-height: 1.45;
    max-width: 760px;
  }

  .rcx-composerBody {
    display: grid;
    grid-template-columns: minmax(0, 1.5fr) minmax(360px, 0.5fr);
    gap: 16px;
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
    padding: 16px 18px 18px;
  }

  .rcx-composerMain {
    display: flex;
    flex-direction: column;
    gap: 14px;
    min-width: 0;
  }

  .rcx-composerAside {
    display: flex;
    flex-direction: column;
    gap: 14px;
    min-width: 0;
  }

  .rcx-sectionCard {
    border-radius: 22px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background:
      linear-gradient(180deg, rgba(12, 18, 34, 0.92), rgba(8, 13, 25, 0.94));
    box-shadow: 0 18px 46px rgba(0, 0, 0, 0.24);
    overflow: hidden;
  }

  .rcx-sectionHead {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: flex-start;
    padding: 18px 18px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .rcx-sectionTitle {
    margin: 0;
    font-size: 1.02rem;
    font-weight: 850;
    color: rgba(245, 248, 255, 0.98);
  }

  .rcx-sectionCopy {
    margin: 6px 0 0;
    color: rgba(205, 219, 242, 0.66);
    font-size: 0.82rem;
    line-height: 1.55;
    max-width: 760px;
  }

  .rcx-sectionBody {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 16px 18px 18px;
  }

  .rcx-formGrid {
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .rcx-formGrid--triple {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .rcx-formGrid--quad {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .rcx-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
  }

  .rcx-field--full {
    grid-column: 1 / -1;
  }

  .rcx-label {
    color: rgba(214, 226, 246, 0.74);
    font-size: 0.71rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-weight: 800;
  }

  .rcx-help {
    color: rgba(205, 219, 242, 0.6);
    font-size: 0.74rem;
    line-height: 1.48;
  }

  .rcx-switchRow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 18px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.025);
  }

  .rcx-switchTitle {
    color: rgba(244, 248, 255, 0.96);
    font-size: 0.84rem;
    font-weight: 850;
  }

  .rcx-switchCopy {
    margin-top: 4px;
    color: rgba(205, 219, 242, 0.66);
    font-size: 0.76rem;
    line-height: 1.5;
  }

  .rcx-switchInput {
    width: 18px;
    height: 18px;
    accent-color: rgba(34, 211, 238, 0.9);
    flex: 0 0 auto;
  }

  .rcx-galleryGrid {
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  }

  .rcx-imageField {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px;
    border-radius: 18px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    background: rgba(255, 255, 255, 0.025);
  }

  .rcx-imagePreview {
    position: relative;
    min-height: 130px;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background:
      linear-gradient(180deg, rgba(6, 9, 18, 0.1), rgba(6, 9, 18, 0.82)),
      radial-gradient(280px 130px at 18% 0%, rgba(34, 211, 238, 0.16), transparent 70%),
      linear-gradient(135deg, rgba(10, 22, 42, 0.94), rgba(13, 17, 32, 0.98));
    background-position: center;
    background-size: cover;
    overflow: hidden;
  }

  .rcx-imagePreview::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(7, 12, 22, 0.08), rgba(7, 12, 22, 0.82));
    pointer-events: none;
  }

  .rcx-imageBadge {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 999px;
    background: rgba(7, 14, 28, 0.54);
    border: 1px solid rgba(255, 255, 255, 0.14);
    color: rgba(239, 244, 255, 0.95);
    font-size: 0.68rem;
    font-weight: 800;
    backdrop-filter: blur(10px);
  }

  .rcx-galleryAdd {
    align-self: flex-start;
  }

  .rcx-previewCard {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 16px;
    position: sticky;
    top: 0;
  }

  .rcx-previewHero {
    position: relative;
    min-height: 250px;
    border-radius: 20px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background:
      linear-gradient(180deg, rgba(6, 9, 18, 0.08), rgba(6, 9, 18, 0.86)),
      radial-gradient(380px 160px at 18% 0%, rgba(34, 211, 238, 0.18), transparent 68%),
      linear-gradient(135deg, rgba(9, 20, 39, 0.94), rgba(13, 18, 34, 0.98));
    background-position: center;
    background-size: cover;
  }

  .rcx-previewHero::after {
    content: "";
    position: absolute;
    inset: 0;
    background:
      linear-gradient(180deg, rgba(6, 9, 18, 0.04), rgba(6, 9, 18, 0.88)),
      linear-gradient(140deg, rgba(34, 211, 238, 0.06), transparent 42%, rgba(249, 115, 22, 0.1));
    pointer-events: none;
  }

  .rcx-previewOverlay {
    position: absolute;
    inset: auto 14px 14px 14px;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .rcx-previewTitle {
    margin: 0;
    font-size: 1.24rem;
    font-weight: 900;
    letter-spacing: -0.03em;
    color: rgba(248, 251, 255, 0.99);
  }

  .rcx-previewCopy {
    color: rgba(231, 238, 250, 0.82);
    font-size: 0.84rem;
    line-height: 1.58;
  }

  .rcx-previewStats {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .rcx-previewStat {
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.025);
    padding: 10px 12px;
  }

  .rcx-previewStatLabel {
    color: rgba(213, 224, 244, 0.58);
    font-size: 0.66rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-weight: 800;
    margin-bottom: 4px;
  }

  .rcx-previewStatValue {
    color: rgba(244, 248, 255, 0.98);
    font-size: 0.84rem;
    font-weight: 900;
    line-height: 1.25;
  }

  .rcx-ingredientWorkspace {
    display: grid;
    grid-template-columns: 1fr;
    gap: 14px;
    align-items: start;
  }

  .rcx-ingredientWorkspace--open {
    grid-template-columns: minmax(0, 1.08fr) minmax(330px, 0.92fr);
  }

  .rcx-recipeDropzone,
  .rcx-ingredientCatalogCard {
    min-width: 0;
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background:
      linear-gradient(180deg, rgba(15, 24, 42, 0.7), rgba(9, 15, 28, 0.86)),
      rgba(255, 255, 255, 0.025);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
  }

  .rcx-recipeDropzone {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-height: 300px;
    padding: 14px;
    transition: border-color 140ms ease, box-shadow 140ms ease, background 140ms ease;
  }

  .rcx-recipeDropzone.is-active {
    border-color: rgba(34, 211, 238, 0.58);
    background:
      linear-gradient(180deg, rgba(12, 32, 50, 0.78), rgba(9, 18, 32, 0.9)),
      rgba(34, 211, 238, 0.05);
    box-shadow: inset 0 0 0 1px rgba(34, 211, 238, 0.14), 0 18px 44px rgba(34, 211, 238, 0.08);
  }

  .rcx-recipeDropHead,
  .rcx-pickerHeader,
  .rcx-productDetailHead {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }

  .rcx-emptyCard--drop {
    min-height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .rcx-ingredientCompactRow {
    display: grid;
    grid-template-columns: 42px minmax(0, 1fr) minmax(120px, 0.34fr) minmax(110px, 0.3fr) minmax(118px, 0.34fr) auto;
    gap: 10px;
    align-items: center;
    border-radius: 18px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    background:
      linear-gradient(180deg, rgba(255, 255, 255, 0.045), rgba(255, 255, 255, 0.022)),
      rgba(255, 255, 255, 0.02);
    padding: 10px 12px;
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.16);
    min-width: 0;
  }

  .rcx-ingredientCompactIndex {
    width: 36px;
    height: 36px;
    border-radius: 13px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(34, 211, 238, 0.25);
    background: rgba(34, 211, 238, 0.08);
    color: rgba(214, 251, 255, 0.96);
    font-size: 0.76rem;
    font-weight: 900;
  }

  .rcx-ingredientCompactMain {
    min-width: 0;
  }

  .rcx-ingredientCompactMain h4 {
    margin: 0;
    color: rgba(245, 248, 255, 0.98);
    font-size: 0.88rem;
    font-weight: 900;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .rcx-ingredientCompactMeta {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 6px;
    color: rgba(205, 219, 242, 0.62);
    font-size: 0.7rem;
    font-weight: 750;
  }

  .rcx-ingredientCompactMeta span {
    min-width: 0;
    max-width: 100%;
    overflow-wrap: anywhere;
  }

  .rcx-ingredientCompactMetric,
  .rcx-ingredientCompactCost {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;
    border-radius: 14px;
    padding: 8px 10px;
    background: rgba(255, 255, 255, 0.03);
  }

  .rcx-ingredientCompactMetric span,
  .rcx-ingredientCompactCost span {
    color: rgba(205, 219, 242, 0.55);
    font-size: 0.62rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-weight: 850;
  }

  .rcx-ingredientCompactMetric strong,
  .rcx-ingredientCompactCost strong {
    color: rgba(244, 248, 255, 0.96);
    font-size: 0.8rem;
    font-weight: 900;
    overflow-wrap: anywhere;
  }

  .rcx-ingredientCompactCost {
    border: 1px solid rgba(52, 211, 153, 0.22);
    background: rgba(52, 211, 153, 0.09);
  }

  .rcx-ingredientCompactCost strong {
    color: rgba(207, 255, 231, 0.98);
  }

  .rcx-ingredientCompactActions {
    display: flex;
    justify-content: flex-end;
    gap: 7px;
  }

  .rcx-lineHead--product {
    align-items: center;
  }

  .rcx-lineProductIntro,
  .rcx-lineHeadActions {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  .rcx-lineProductIntro > div {
    min-width: 0;
  }

  .rcx-lineHeadActions {
    flex: 0 0 auto;
  }

  .rcx-lineNumber {
    width: 38px;
    height: 38px;
    border-radius: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(34, 211, 238, 0.25);
    background: rgba(34, 211, 238, 0.08);
    color: rgba(214, 251, 255, 0.96);
    font-size: 0.78rem;
    font-weight: 900;
    flex: 0 0 auto;
  }

  .rcx-inlineBtn--icon {
    display: inline-flex;
    align-items: center;
    width: 34px;
    height: 34px;
    justify-content: center;
    padding: 0;
  }

  .rcx-lineProductGrid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(170px, 0.34fr);
    gap: 12px;
    align-items: stretch;
  }

  .rcx-lineProductInfo,
  .rcx-lineCostPanel,
  .rcx-productDetailCard {
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.025);
  }

  .rcx-lineProductInfo {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
    padding: 12px;
  }

  .rcx-lineSupplier {
    color: rgba(222, 233, 250, 0.78);
    font-size: 0.78rem;
    font-weight: 800;
    overflow-wrap: anywhere;
  }

  .rcx-lineDescription,
  .rcx-productDescription {
    color: rgba(205, 219, 242, 0.66);
    font-size: 0.76rem;
    line-height: 1.48;
    overflow-wrap: anywhere;
  }

  .rcx-lineCostPanel {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 10px;
  }

  .rcx-miniMetric {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    border-radius: 13px;
    padding: 8px 10px;
    background: rgba(255, 255, 255, 0.035);
  }

  .rcx-miniMetric span {
    color: rgba(205, 219, 242, 0.62);
    font-size: 0.66rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-weight: 800;
  }

  .rcx-miniMetric strong {
    color: rgba(245, 249, 255, 0.98);
    font-size: 0.82rem;
    font-weight: 900;
    text-align: right;
  }

  .rcx-miniMetric--accent {
    background: rgba(52, 211, 153, 0.1);
    border: 1px solid rgba(52, 211, 153, 0.22);
  }

  .rcx-lineControlDeck {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 0.85fr) minmax(150px, 0.65fr);
    gap: 10px;
    align-items: start;
  }

  .rcx-segmentGroup {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
  }

  .rcx-segmentBtn {
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.035);
    color: rgba(226, 235, 249, 0.8);
    padding: 8px 11px;
    font-size: 0.74rem;
    font-weight: 850;
    cursor: pointer;
    transition: border-color 120ms ease, background 120ms ease, color 120ms ease, transform 120ms ease;
  }

  .rcx-segmentBtn:hover,
  .rcx-segmentBtn.is-active {
    border-color: rgba(34, 211, 238, 0.5);
    background: rgba(34, 211, 238, 0.13);
    color: rgba(218, 251, 255, 0.98);
  }

  .rcx-input--quantity {
    font-weight: 900;
  }

  .rcx-ingredientCatalogCard {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 14px;
    position: sticky;
    top: 0;
  }

  .rcx-pickerTitle {
    margin: 4px 0 0;
    color: rgba(245, 248, 255, 0.98);
    font-size: 0.98rem;
    font-weight: 900;
  }

  .rcx-pickerSearch {
    display: flex;
    align-items: center;
    gap: 9px;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.045);
    color: rgba(219, 234, 254, 0.75);
    padding: 10px 12px;
  }

  .rcx-pickerSearch input {
    width: 100%;
    border: 0;
    outline: 0;
    background: transparent;
    color: rgba(241, 246, 255, 0.96);
    font-size: 0.82rem;
    min-width: 0;
  }

  .rcx-pickerSearch input::placeholder {
    color: rgba(217, 229, 247, 0.44);
  }

  .rcx-pickerTrail {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
  }

  .rcx-trailBtn {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.035);
    color: rgba(218, 229, 247, 0.8);
    border-radius: 999px;
    padding: 6px 10px;
    font-size: 0.7rem;
    font-weight: 850;
    cursor: pointer;
    max-width: 100%;
  }

  .rcx-pickerMode {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    color: rgba(205, 219, 242, 0.72);
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-weight: 850;
  }

  .rcx-pickerMode strong {
    color: rgba(244, 248, 255, 0.96);
  }

  .rcx-pickerBubbleGrid,
  .rcx-productBubbleGrid {
    display: grid;
    gap: 9px;
    max-height: 420px;
    overflow: auto;
    padding-right: 3px;
  }

  .rcx-pickerBubbleGrid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }

  .rcx-productBubbleGrid {
    grid-template-columns: 1fr;
  }

  .rcx-pickerBubble,
  .rcx-productBubble {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background:
      linear-gradient(180deg, rgba(255, 255, 255, 0.055), rgba(255, 255, 255, 0.025)),
      rgba(255, 255, 255, 0.025);
    color: rgba(237, 244, 255, 0.94);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.16);
  }

  .rcx-pickerBubble {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 4px 8px;
    align-items: center;
    border-radius: 16px;
    padding: 11px 12px;
    text-align: left;
    cursor: pointer;
  }

  .rcx-pickerBubble span,
  .rcx-productBubble h5 {
    margin: 0;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.82rem;
    font-weight: 900;
  }

  .rcx-pickerBubble small {
    grid-column: 1 / -1;
    color: rgba(205, 219, 242, 0.62);
    font-size: 0.7rem;
    font-weight: 750;
  }

  .rcx-productBubble {
    border-radius: 17px;
    padding: 12px;
    cursor: grab;
    outline: none;
    transition: border-color 120ms ease, background 120ms ease, transform 120ms ease, box-shadow 120ms ease;
  }

  .rcx-productBubble:active {
    cursor: grabbing;
  }

  .rcx-productBubble:hover,
  .rcx-productBubble:focus,
  .rcx-productBubble.is-selected {
    border-color: rgba(34, 211, 238, 0.46);
    background:
      linear-gradient(180deg, rgba(34, 211, 238, 0.1), rgba(255, 255, 255, 0.03)),
      rgba(255, 255, 255, 0.035);
    box-shadow: 0 16px 38px rgba(34, 211, 238, 0.08);
  }

  .rcx-productBubbleTop {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    min-width: 0;
  }

  .rcx-productBubbleTop > div {
    min-width: 0;
  }

  .rcx-productBubbleTop p {
    margin: 4px 0 0;
    color: rgba(205, 219, 242, 0.62);
    font-size: 0.72rem;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .rcx-productBubbleMeta {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;
  }

  .rcx-productBubbleMeta span {
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.035);
    color: rgba(215, 226, 244, 0.72);
    font-size: 0.68rem;
    font-weight: 800;
    padding: 5px 8px;
    max-width: 100%;
    overflow-wrap: anywhere;
  }

  .rcx-productAddBtn {
    margin-top: 11px;
    width: 100%;
    border: 1px solid rgba(52, 211, 153, 0.28);
    border-radius: 13px;
    background: rgba(52, 211, 153, 0.11);
    color: rgba(209, 255, 231, 0.96);
    padding: 9px 11px;
    font-size: 0.76rem;
    font-weight: 900;
    cursor: pointer;
  }

  .rcx-productAddBtn:disabled {
    opacity: 0.62;
    cursor: wait;
  }

  .rcx-productDetailCard {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 13px;
  }

  .rcx-productDetailHead h5 {
    margin: 4px 0 0;
    color: rgba(245, 248, 255, 0.98);
    font-size: 0.92rem;
    font-weight: 900;
  }

  .rcx-productDetailGrid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .rcx-productDetailGrid div {
    border-radius: 13px;
    background: rgba(255, 255, 255, 0.035);
    padding: 8px 9px;
    min-width: 0;
  }

  .rcx-productDetailGrid span {
    display: block;
    color: rgba(205, 219, 242, 0.58);
    font-size: 0.63rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-weight: 800;
    margin-bottom: 4px;
  }

  .rcx-productDetailGrid strong {
    display: block;
    color: rgba(244, 248, 255, 0.95);
    font-size: 0.78rem;
    font-weight: 900;
    overflow-wrap: anywhere;
  }

  .rcx-productDetailAction {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    justify-content: center;
  }

  .rcx-lineStack {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .rcx-lineCard {
    border-radius: 18px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    background: rgba(255, 255, 255, 0.024);
    overflow: hidden;
    box-shadow: 0 14px 36px rgba(0, 0, 0, 0.18);
  }

  .rcx-lineCard--draft {
    border-color: rgba(34, 211, 238, 0.16);
    background:
      linear-gradient(180deg, rgba(34, 211, 238, 0.035), rgba(255, 255, 255, 0.022)),
      rgba(255, 255, 255, 0.024);
  }

  .rcx-lineHead {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 14px 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  }

  .rcx-lineTitle {
    margin: 0;
    font-size: 0.92rem;
    font-weight: 850;
    color: rgba(245, 248, 255, 0.97);
    overflow-wrap: anywhere;
  }

  .rcx-lineSubtitle {
    margin: 4px 0 0;
    color: rgba(205, 219, 242, 0.66);
    font-size: 0.76rem;
    line-height: 1.45;
  }

  .rcx-lineCost {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border-radius: 999px;
    padding: 8px 12px;
    border: 1px solid rgba(52, 211, 153, 0.34);
    background: rgba(52, 211, 153, 0.1);
    color: rgba(206, 255, 231, 0.97);
    font-size: 0.76rem;
    font-weight: 900;
    white-space: nowrap;
  }

  .rcx-lineBody {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 14px;
  }

  .rcx-lineGrid {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .rcx-lineGrid--compact {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .rcx-valueHint {
    color: rgba(205, 219, 242, 0.62);
    font-size: 0.72rem;
    line-height: 1.4;
  }

  .rcx-lineFooter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .rcx-lineMeta {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .rcx-footerBar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .rcx-totalCard {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    border-radius: 18px;
    border: 1px solid rgba(249, 115, 22, 0.34);
    background: rgba(249, 115, 22, 0.12);
    color: rgba(255, 228, 211, 0.98);
    font-weight: 900;
    font-size: 0.9rem;
  }

  .rcx-inlineBtn {
    padding: 7px 12px;
    font-size: 0.74rem;
  }

  .rcx-confirmLineBtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    border-radius: 999px;
    border: 1px solid rgba(52, 211, 153, 0.34);
    background: rgba(52, 211, 153, 0.12);
    color: rgba(207, 255, 231, 0.98);
    padding: 8px 12px;
    font-size: 0.74rem;
    font-weight: 900;
    cursor: pointer;
  }

  .rcx-closeBtn {
    min-width: 40px;
    height: 40px;
    padding: 0;
    font-size: 1rem;
    line-height: 1;
  }

  .rcx-alert {
    border-radius: 16px;
    border: 1px solid rgba(248, 113, 113, 0.36);
    background: rgba(248, 113, 113, 0.12);
    color: rgba(255, 210, 210, 0.98);
    padding: 11px 13px;
    font-size: 0.82rem;
    font-weight: 700;
  }

  .rcx-mobileList {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .rcx-mobileCard {
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.028);
    overflow: hidden;
    box-shadow: 0 16px 42px rgba(0, 0, 0, 0.24);
  }

  @media (max-width: 1180px) {
    .rcx-headerHead {
      flex-direction: column;
    }

    .rcx-headerControls {
      width: 100%;
      align-items: stretch;
    }

    .rcx-filterChips {
      justify-content: flex-start;
    }

    .rcx-panelHeadActions {
      width: 100%;
      max-width: 100%;
      align-items: flex-start;
    }

    .rcx-workspace,
    .rcx-topbarSummary {
      grid-template-columns: 1fr;
    }

    .rcx-dashboard {
      grid-template-columns: 1fr;
    }

    .rcx-heroCard,
    .rcx-composerBody {
      grid-template-columns: 1fr;
    }

    .rcx-previewCard {
      position: static;
    }

    .rcx-ingredientWorkspace--open {
      grid-template-columns: 1fr;
    }

    .rcx-ingredientCatalogCard {
      position: static;
    }
  }

  @media (max-width: 900px) {
    .rcx-page {
      overflow: auto;
    }

    .rcx-headerHead {
      padding: 16px 16px 14px;
    }

    .rcx-headerError {
      padding-left: 16px;
      padding-right: 16px;
    }

    .rcx-topbarHeader,
    .rcx-topbarNavigatorHead {
      align-items: flex-start;
    }

    .rcx-topbarFeature,
    .rcx-compactRow {
      grid-template-columns: 1fr;
    }

    .rcx-searchRow,
    .rcx-formGrid,
    .rcx-formGrid--triple,
    .rcx-formGrid--quad,
    .rcx-lineGrid,
    .rcx-lineGrid--compact,
    .rcx-lineProductGrid,
    .rcx-lineControlDeck {
      grid-template-columns: 1fr;
    }

    .rcx-lineHead--product,
    .rcx-recipeDropHead,
    .rcx-pickerHeader,
    .rcx-productDetailHead {
      flex-direction: column;
    }

    .rcx-lineHeadActions {
      width: 100%;
      justify-content: space-between;
    }

    .rcx-ingredientCompactRow {
      grid-template-columns: 38px minmax(0, 1fr);
      align-items: start;
    }

    .rcx-ingredientCompactMetric,
    .rcx-ingredientCompactCost,
    .rcx-ingredientCompactActions {
      grid-column: 2;
    }

    .rcx-ingredientCompactActions {
      justify-content: flex-start;
    }

    .rcx-cardMetrics,
    .rcx-previewStats,
    .rcx-featureStats,
    .rcx-topbarStats,
    .rcx-navMetrics {
      grid-template-columns: 1fr 1fr;
    }

    .rcx-topbarStats {
      width: 100%;
    }
  }

  @media (max-width: 640px) {
    .rcx-shell {
      padding: 12px;
    }

    .rcx-modalBackdrop {
      --rcx-composer-gutter: 0px;
      padding: 0;
    }

    .rcx-heroCard,
    .rcx-panel,
    .rcx-composer,
    .rcx-previewCard {
      border-radius: 18px;
    }

    .rcx-heroCard,
    .rcx-toolbar,
    .rcx-stats,
    .rcx-gallerySection,
    .rcx-panelHead,
    .rcx-composerHeader,
    .rcx-composerBody,
    .rcx-sectionBody,
    .rcx-sectionHead {
      padding-left: 14px;
      padding-right: 14px;
    }

    .rcx-cardMetrics,
    .rcx-previewStats,
    .rcx-featureStats,
    .rcx-topbarStats,
    .rcx-navMetrics,
    .rcx-compactStats,
    .rcx-productDetailGrid {
      grid-template-columns: 1fr;
    }

    .rcx-topbarStats {
      width: 100%;
    }

    .rcx-composerBody {
      padding-top: 14px;
      padding-bottom: 14px;
    }

    .rcx-composer {
      border-radius: 0;
    }

    .rcx-navCard {
      grid-template-columns: 1fr;
    }
  }

  @media (max-height: 820px) {
    .rcx-shell { zoom: 0.9; height: calc((100dvh - 28px) / 0.9); }
    .rcx-modalBackdrop { --rcx-composer-zoom: 0.9; }
  }

  @media (max-height: 720px) {
    .rcx-shell { zoom: 0.8; height: calc((100dvh - 28px) / 0.8); }
    .rcx-modalBackdrop { --rcx-composer-zoom: 0.8; }
  }

  @media (max-height: 620px) {
    .rcx-shell { zoom: 0.7; height: calc((100dvh - 28px) / 0.7); }
    .rcx-modalBackdrop { --rcx-composer-zoom: 0.7; }
  }
`;

const EMPTY_RECIPE_NARRATIVE = {
  description: "",
  preparation_steps: "",
  internal_notes: "",
  gallery_urls: [],
  yield_quantity: "",
  legacy_text: "",
};

const recipeLocale = (languageId) => String(languageId || "es").toLowerCase().startsWith("en") ? "en-GB" : "es-ES";

export function formatRecipeCurrency(value, languageId = "es") {
  const numeric = Number(value || 0);
  return new Intl.NumberFormat(recipeLocale(languageId), {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number.isFinite(numeric) ? numeric : 0);
}

export function formatRecipeNumber(value, digits = 2, languageId = "es") {
  const numeric = Number(value || 0);
  if (!Number.isFinite(numeric)) return "-";
  return new Intl.NumberFormat(recipeLocale(languageId), {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  }).format(numeric);
}

export function formatRecipeDate(value, languageId = "es") {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return new Intl.DateTimeFormat(recipeLocale(languageId), {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(date);
}

export function truncateRecipeText(value, maxLength = 72) {
  const text = String(value || "-");
  if (text.length <= maxLength) return text;
  return `${text.slice(0, Math.max(0, maxLength - 3)).trimEnd()}...`;
}

export function getRecipeTypeMeta(value, languageId = "en") {
  const type = String(value || "finished").toLowerCase();
  const spanish = languageId === "es";

  if (type === "intermediate") {
    return {
      value: type,
      label: spanish ? "Intermedia" : "Intermediate",
      className: "rcx-typeBadge rcx-typeBadge--intermediate",
      accent: "mint",
    };
  }

  if (type === "auxiliary") {
    return {
      value: type,
      label: spanish ? "Auxiliar" : "Auxiliary",
      className: "rcx-typeBadge rcx-typeBadge--auxiliary",
      accent: "amber",
    };
  }

  return {
    value: "finished",
    label: spanish ? "Terminada" : "Finished",
    className: "rcx-typeBadge rcx-typeBadge--finished",
    accent: "cyan",
  };
}

export function parseRecipeNarrative(rawValue) {
  if (!rawValue) return { ...EMPTY_RECIPE_NARRATIVE };

  if (typeof rawValue === "object" && rawValue !== null) {
    return {
      ...EMPTY_RECIPE_NARRATIVE,
      description: String(rawValue.description || "").trim(),
      preparation_steps: String(rawValue.preparation_steps || "").trim(),
      internal_notes: String(rawValue.internal_notes || "").trim(),
      gallery_urls: normalizeGalleryUrls(rawValue.gallery_urls),
      yield_quantity:
        rawValue.yield_quantity === null || rawValue.yield_quantity === undefined
          ? ""
          : String(rawValue.yield_quantity).trim(),
      legacy_text: "",
    };
  }

  const text = String(rawValue).trim();
  if (!text) return { ...EMPTY_RECIPE_NARRATIVE };

  try {
    const parsed = JSON.parse(text);
    if (
      parsed &&
      typeof parsed === "object" &&
      (Object.prototype.hasOwnProperty.call(parsed, "description") ||
        Object.prototype.hasOwnProperty.call(parsed, "preparation_steps") ||
        Object.prototype.hasOwnProperty.call(parsed, "gallery_urls") ||
        Object.prototype.hasOwnProperty.call(parsed, "yield_quantity") ||
        Object.prototype.hasOwnProperty.call(parsed, "internal_notes"))
    ) {
      return parseRecipeNarrative(parsed);
    }
  } catch (error) {
    // Legacy plain-text notes fall through.
  }

  return {
    ...EMPTY_RECIPE_NARRATIVE,
    internal_notes: text,
    legacy_text: text,
  };
}

export function serializeRecipeNarrative(value) {
  const description = String(value?.description || "").trim();
  const preparation_steps = String(value?.preparation_steps || "").trim();
  const internal_notes = String(value?.internal_notes || "").trim();
  const gallery_urls = normalizeGalleryUrls(value?.gallery_urls);
  const yield_quantity = String(value?.yield_quantity ?? "").trim();

  if (!description && !preparation_steps && !internal_notes && !gallery_urls.length && !yield_quantity) {
    return "";
  }

  return JSON.stringify({
    version: 2,
    description,
    preparation_steps,
    internal_notes,
    gallery_urls,
    yield_quantity: yield_quantity ? Number(yield_quantity) : null,
  });
}

export function normalizeGalleryUrls(value) {
  if (!Array.isArray(value)) return [];
  return value
    .map((entry) => String(entry || "").trim())
    .filter(Boolean);
}

export function getRecipeVisualGallery(recipe) {
  const narrative = parseRecipeNarrative(recipe?.technical_notes);
  const cover = String(recipe?.photo_url || "").trim();
  return [cover, ...narrative.gallery_urls].filter(Boolean);
}

export function getRecipeYieldQuantity(recipe) {
  const narrative = parseRecipeNarrative(recipe?.technical_notes);
  const numeric = Number(narrative.yield_quantity || 0);
  return Number.isFinite(numeric) && numeric > 0 ? numeric : 0;
}

export function getRecipeCostPerYield(recipe) {
  const yieldQuantity = getRecipeYieldQuantity(recipe);
  if (!yieldQuantity) return null;
  const totalCost = Number(recipe?.total_cost || 0);
  if (!Number.isFinite(totalCost)) return null;
  return totalCost / yieldQuantity;
}

export function getRecipeShortDescription(recipe) {
  const narrative = parseRecipeNarrative(recipe?.technical_notes);
  return (
    narrative.description ||
    narrative.internal_notes ||
    "No culinary story added yet. Open the recipe to shape its cover, gallery and preparation voice."
  );
}

export function getRecipePreparationPreview(recipe) {
  const narrative = parseRecipeNarrative(recipe?.technical_notes);
  if (!narrative.preparation_steps) return [];
  return narrative.preparation_steps
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .slice(0, 4);
}

export function getRecipeVisualStyle(recipeType, imageUrl = "") {
  const cover = String(imageUrl || "").trim();

  if (cover) {
    return {
      backgroundImage: [
        "linear-gradient(180deg, rgba(23, 38, 83, 0.04), rgba(23, 38, 83, 0.6))",
        `url(${JSON.stringify(cover)})`,
      ].join(", "),
    };
  }

  return {
    backgroundImage: "none",
    backgroundColor: "#223a7a",
  };
}
